import { render, staticRenderFns } from "./TheFullViewportContainer.vue?vue&type=template&id=dab5fcc4&scoped=true"
import script from "./TheFullViewportContainer.vue?vue&type=script&lang=js"
export * from "./TheFullViewportContainer.vue?vue&type=script&lang=js"
import style0 from "./TheFullViewportContainer.vue?vue&type=style&index=0&id=dab5fcc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.97.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab5fcc4",
  null
  
)

export default component.exports